export default __webpack_public_path__ + "static/media/img17.9048ec8b.PNG";